import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Sales module landing page.
 *
 * Owner (2026-10-05): the department pages show MODULES, one card per module, the same
 * cards as General SS White (DeptLandingSections); a card shows only when the person may
 * open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * The route is gated by dept.sales in allRoutes.js.
 */
const MODULES = ["cr", "project", "app-visitors", "tasks", "dms", "epo", "kpi"];

const Sales = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-line-chart-line"
                        eyebrow="Revenue"
                        title="Sales"
                        subtitle="Pipeline, quotes, and revenue at a glance"
                        tone="amber"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Sales" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="sales" title="Sales modules" icon="ri-briefcase-line" />

                    <ComingSoonCard
                        compact
                        icon="ri-line-chart-line"
                        title="More for Sales later"
                        message="Ideas for later: pipeline by stage, quote-to-order conversion and revenue forecasts. The modules above are live today."
                        tone="warning"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Sales;
